import * as React from 'react'
import { Route, BrowserRouter, Routes } from 'react-router-dom'
import IRoute from '../IRoute'
import RoleRequiredRouteWrapper from '../RoleRequiredRoute'

const renderRoute = (route: IRoute, index: number) => {
  if (
    (route.allowedRoles && route.allowedRoles.length > 0) ||
    (route.allowedOrganization && route.allowedOrganization.length > 0)
  ) {
    return (
      <Route
        key={index}
        path={route.path}
        element={<RoleRequiredRouteWrapper route={route} />}
      />
    )
  } else {
    return <Route key={index} path={route.path} element={<route.component />} />
  }
}

interface IRouterProps {
  container: React.ComponentClass | React.FunctionComponent
  containerProps?: any
  routes: IRoute[]
  children?: React.ReactNode
}

const RouterWrapper: React.FC<IRouterProps> = (props) => (
  <BrowserRouter>
    <>
      {props.children}
      <props.container {...props.containerProps}>
        <Routes>{props.routes.map(renderRoute)}</Routes>
      </props.container>
    </>
  </BrowserRouter>
)

export type { IRoute, IRouterProps }
export default RouterWrapper
